/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon24Regular = forwardRef('WeatherUmbrellaIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 1.75a.75.75 0 0 0-1.5 0v1.276a10.502 10.502 0 0 0-9.728 9.791c-.043.661.49 1.183 1.116 1.183h8.612v5.5a1.5 1.5 0 0 1-3 0 .75.75 0 0 0-1.5 0 3 3 0 1 0 6 0V14h8.612c.626 0 1.159-.522 1.116-1.183a10.502 10.502 0 0 0-9.728-9.79V1.75Zm8.195 10.75a9.001 9.001 0 0 0-17.89 0h17.89Z" })));
});
